module.exports = __webpack_public_path__ + "img/2025-05-09c_6.ad231202.jpg";